import { useQuery } from "@tanstack/react-query";

import { api } from "@/shared/api";
import { MAX_AVATAR_VIDEO_SECONDS } from "./dhUploadLimits";

/**
 * 分身源视频时长上下限(1030,给 features 之外/跨 feature 的上传口用)。
 *
 * 与 features/digital-human 的 `useDhVideoLimits` 读**同一个接口、同一个 queryKey**(缓存共享),
 * 这里只取源视频两项;拿不到回落老口径 120 秒、不设下限(宁可少放开)。
 */
export interface DhSourceLimits {
  minSourceSec: number;
  maxSourceSec: number;
}

const pos = (v: unknown): number =>
  typeof v === "number" && Number.isFinite(v) && v > 0 ? Math.floor(v) : 0;

export function useDhSourceLimits(): DhSourceLimits {
  const q = useQuery({
    queryKey: ["dh", "video-limits"],
    queryFn: () =>
      api.get<{ minSourceSec?: number; maxSourceSec?: number }>("/digital-human/video-limits"),
    staleTime: 10 * 60_000,
    retry: 1,
  });
  const max = pos(q.data?.maxSourceSec);
  if (!max) return { minSourceSec: 0, maxSourceSec: MAX_AVATAR_VIDEO_SECONDS };
  return { minSourceSec: pos(q.data?.minSourceSec), maxSourceSec: max };
}
